import cn from 'classnames';
import { LinkFormData } from './contracts';
import { Link as ReactLink } from 'react-router';

export type LinkProps = LinkFormData & {
  className?: string;
};

export default function Link({ className, url, openInNewTab, label, variant, size }: LinkProps) {
  return (
    <>
      {(url as string).startsWith('#') ? (
        <ReactLink to={url} className={cn(`link-button-${variant}`, `link-button-${variant}--${size}`, className)}>
          {label}
        </ReactLink>
      ) : (
        <ReactLink
          className={cn(`link-button-${variant}`, `link-button-${variant}--${size}`, className)}
          to={url}
          target={openInNewTab ? '_blank' : '_self'}
        >
          {label}
        </ReactLink>
      )}
    </>
  );
}
